import { Workspace } from "developer/workspaces/model";
import { getAllWorkspaces } from "developer/workspaces/store";
import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";

type WorkspaceHash = {
  [workspaceId: string]: Workspace;
};

const useWorkspaces = (): WorkspaceHash => {
  const dispatch = useAppDispatch();
  const { workspaces, isLoading, isReloadNeeded, error } = useAppSelector(
    (state) => state.developer.workspaces
  );

  useEffect(() => {
    if (!isLoading && !error && isReloadNeeded) {
      dispatch(getAllWorkspaces());
    }
  }, [dispatch, isLoading, error, isReloadNeeded]);

  const workspacesHash = useMemo(() => {
    const hash: WorkspaceHash = {};

    workspaces.forEach((item) => {
      if (item.id) {
        hash[item.id] = item;
      }
    });

    return hash;
  }, [workspaces]);

  return workspacesHash;
};

export default useWorkspaces;
